import React from "react";
import { actionsForStatus, ACTION_LABELS } from "./AssetActionDialogs";

/**
 * "⋯" menu with the actions allowed for the asset's status.
 * onAction(key) — key is e.g. "assign", "edit", "status:Retired".
 */
const AssetActionsMenu = ({ asset, onAction, align = "end" }) => {
  if (asset.deletedAt)
    return <span className="text-slate-400 fs-075">Deleted</span>;
  const actions = actionsForStatus(asset.status);
  return (
    <div className="dropdown" onClick={(e) => e.stopPropagation()}>
      <button
        type="button"
        className="btn btn-sm btn-light border rounded-6 px-2"
        data-bs-toggle="dropdown"
        data-bs-popper-config='{"strategy":"fixed"}'
        aria-expanded="false"
        aria-label={`Actions for ${asset.assetTag}`}
      >
        <i className="bi bi-three-dots"></i>
      </button>
      <ul className={`dropdown-menu dropdown-menu-${align} shadow-sm fs-085`}>
        {actions.map((key) => {
          const meta = ACTION_LABELS[key];
          return (
            <li key={key}>
              <button
                type="button"
                className={`dropdown-item d-flex align-items-center gap-2 ${meta.danger ? "text-danger" : ""}`}
                onClick={() => onAction(key)}
              >
                <i className={`bi ${meta.icon}`}></i> {meta.label}
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default AssetActionsMenu;
